<template>
  <div class="mb-6">
    <details class="group border border-base-200 rounded-xl overflow-hidden transition-shadow hover:shadow-lg" open>
      <SummaryToggle
        :title="section.title"
        :icon="defaultIcons[sectionIndex % defaultIcons.length]"
        :sectionIndex="sectionIndex"
        :isHovered="hovering === sectionIndex"
        @update:hovering="$emit('update:hovering', $event)" />

      <SummarySectionQuestions
        :section="section"
        :answers="answers"
        :sectionIndex="sectionIndex"
        @navigate="$emit('navigate', $event)" />
    </details>
  </div>
</template>

<script setup lang="ts">
import { MapPin, Pencil, Rocket, Layers, Settings, Target } from "lucide-vue-next";
import { QuestionSchema } from "@/features/blueprint/schema/questions/QuestionSchema";
import { Answers } from "@/features/blueprint/schema/answers/Answers";
import SummarySectionQuestions from "@/features/blueprint/components/summary/SummarySectionQuestions.vue";
import SummaryToggle from "@/features/blueprint/components/summary/SummaryToggle.vue";

defineProps<{
  section: QuestionSchema;
  sectionIndex: number;
  answers: Answers;
  hovering: number | null;
}>();

const emit = defineEmits<{
  (e: "navigate", index: number): void;
  (e: "update:hovering", hovering: number | null): void;
}>();

const defaultIcons = [Target, Pencil, Layers, Rocket, Settings, MapPin];
</script>
